module.exports = __webpack_public_path__ + "img/ri.15c93c77.gif";